import React, { ReactNode } from "react";

interface AuthCardProps {
  children: ReactNode;
  maxWidth?: string;
  minHeight?: string;
  className?: string;
  title?: string;
  description?: string;
}

const AuthCard: React.FC<AuthCardProps> = ({
  children,
  title,
  description,
  maxWidth = "532px",
  minHeight = "auto",
  className = "",
}) => {
  return (
    <div
      className={`bg-white rounded-[18px] w-full ${className}`}
      style={{
        maxWidth,
        minHeight,
      }}
    >
      <div className="flex flex-col items-center justify-center mb-2">
        <h2 className="text-xl font-semibold text-titleText mt-4">{title}</h2>
        <p className="!text-[1rem] sm:text-sm !text-secondaryGray text-center mt-1 text-center w-full">
          {description}
        </p>
      </div>
      {children}
    </div>
  );
};

export default AuthCard;
